// One toast per message. react-hot-toast replaces a toast that shares an id
// instead of stacking a copy, so a string message without its own id is
// keyed by type and text: three clicks on a failing action show one toast,
// whose timer starts again. Installed once, from main.jsx.
import toast from "react-hot-toast";

const keyed = (show, type) => (message, options) =>
  typeof message === "string" && options?.id == null
    ? show(message, { ...options, id: `${type}:${message}` })
    : show(message, options);

let installed = false;

export const installToastDedupe = () => {
  if (installed) return;
  installed = true;
  toast.success = keyed(toast.success, "success");
  toast.error = keyed(toast.error, "error");
};
